/* gifti-survey.js — GiftInSong Survey Logic */
'use strict';

(function(){

/* ── STATE ─────────────────────────────────────────────── */
var DATA = {
  recipient: '',
  occasion:  '',
  emotion:   '',
  style:     '',
  story:     '',
  names:     '',
  details:   '',
  voice:     '',
  email:     ''
};
var currentStep = 1;
var totalSteps  = 10;

/* Pre-fill from URL params (e.g. ?occasion=Birthday from occasions grid) */
(function prefill(){
  try {
    var params = new URLSearchParams(window.location.search);
    if(params.get('occasion')) DATA.occasion = decodeURIComponent(params.get('occasion'));
  } catch(e){}
})();

/* ── NAVIGATION ─────────────────────────────────────────── */
window.nextStep = function(from) {
  if(!validate(from)) return;
  collectData(from);
  showStep(from + 1);
};

window.prevStep = function(from) {
  showStep(from - 1);
};

function showStep(n) {
  if(n < 1 || n > totalSteps) return;
  document.getElementById('step-' + currentStep).style.display = 'none';
  currentStep = n;
  var el = document.getElementById('step-' + n);
  el.style.display = 'block';
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  updateProgress(n);
  if(n === 10) populateReview();
}

function updateProgress(n) {
  var pct = Math.round((n / totalSteps) * 100);
  document.getElementById('progressFill').style.width = pct + '%';
  document.getElementById('stepCount').textContent = 'Step ' + n + ' of ' + totalSteps;
}

/* ── VALIDATION ─────────────────────────────────────────── */
function validate(step) {
  hideError(step);
  if(step === 1) {
    var v = document.getElementById('s1_recipient').value.trim();
    if(!v){ showError(1, 'Please enter a name.'); return false; }
    DATA.recipient = v;
    document.querySelectorAll('#recipientNameDisplay').forEach(function(el){ el.textContent = v.split(' ')[0] + '!'; });
    return true;
  }
  if(step === 2) {
    var sel = document.querySelector('#s2_grid .option-btn.sel');
    if(!sel){ showError(2, 'Please choose an occasion.'); return false; }
    DATA.occasion = sel.dataset.val;
    return true;
  }
  if(step === 3) {
    var sel = document.querySelector('#s3_grid .option-btn.sel');
    if(!sel){ showError(3, 'Please choose an emotion.'); return false; }
    DATA.emotion = sel.dataset.val;
    return true;
  }
  if(step === 4) {
    var sel = document.querySelector('#s4_grid .option-btn.sel');
    if(!sel){ showError(4, 'Please choose a music style.'); return false; }
    DATA.style = sel.dataset.val;
    return true;
  }
  if(step === 5) {
    var v = document.getElementById('s5_story').value.trim();
    if(v.split(/\s+/).length < 15){ showError(5, 'Please share at least a few sentences so we can write something truly personal.'); return false; }
    DATA.story = v;
    return true;
  }
  if(step === 6) {
    var v = document.getElementById('s6_names').value.trim();
    if(!v){ showError(6, 'Please add at least one name to include in the song.'); return false; }
    DATA.names = v;
    return true;
  }
  if(step === 7) {
    DATA.details = document.getElementById('s7_details').value.trim();
    return true; // optional step
  }
  if(step === 8) {
    var sel = document.querySelector('#s8_grid .radio-option.sel');
    if(!sel){ showError(8, 'Please select a voice preference.'); return false; }
    DATA.voice = sel.dataset.val;
    return true;
  }
  if(step === 9) {
    var v = document.getElementById('s9_email').value.trim();
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!re.test(v)){ showError(9, 'Please enter a valid email address.'); return false; }
    DATA.email = v;
    return true;
  }
  return true;
}

function collectData(step) {
  /* Already collected in validate(), but catch step 7 (optional) */
  if(step === 7) DATA.details = document.getElementById('s7_details').value.trim();
}

function showError(step, msg) {
  var el = document.getElementById('e' + step);
  if(el){ el.textContent = msg; el.classList.add('show'); }
}
function hideError(step) {
  var el = document.getElementById('e' + step);
  if(el) el.classList.remove('show');
}

/* ── OPTION GRID SELECTION ──────────────────────────────── */
document.querySelectorAll('.option-grid').forEach(function(grid){
  grid.addEventListener('click', function(e){
    var btn = e.target.closest('.option-btn');
    if(!btn) return;
    grid.querySelectorAll('.option-btn').forEach(function(b){ b.classList.remove('sel'); });
    btn.classList.add('sel');
  });
});

/* ── RADIO SELECTION ────────────────────────────────────── */
window.selectRadio = function(gridId, el) {
  document.querySelectorAll('#' + gridId + ' .radio-option').forEach(function(r){ r.classList.remove('sel'); });
  el.classList.add('sel');
};

/* ── CHARACTER COUNTER ──────────────────────────────────── */
window.updateCharCount = function(inputId, countId, max) {
  var len = document.getElementById(inputId).value.length;
  document.getElementById(countId).textContent = len + ' / ' + max + ' characters';
};

/* ── REVIEW STEP ────────────────────────────────────────── */
function populateReview() {
  setText('rv_recipient', DATA.recipient);
  setText('rv_occasion',  DATA.occasion);
  setText('rv_emotion',   DATA.emotion);
  setText('rv_style',     DATA.style);
  setText('rv_names',     DATA.names);
  setText('rv_voice',     DATA.voice);
  setText('rv_email',     DATA.email);
}
function setText(id, val) {
  var el = document.getElementById(id);
  if(el) el.textContent = val || '—';
}

/* ── PRE-SELECT OCCASION FROM URL PARAM ─────────────────── */
(function preSelectOccasion(){
  if(!DATA.occasion) return;
  var btn = document.querySelector('#s2_grid .option-btn[data-val="' + DATA.occasion + '"]');
  if(btn){ btn.classList.add('sel'); DATA.occasion = btn.dataset.val; }
})();

/* ── ADD TO CART + CHECKOUT ─────────────────────────────── */

window.addToCartAndCheckout = function() {
  var btn = document.getElementById('checkoutBtn');
  if (btn) { btn.textContent = 'Processing…'; btn.disabled = true; }

  // Safety timeout - re-enable button after 15s if nothing happens
  var safetyTimer = setTimeout(function() {
    if (btn) { btn.disabled = false; btn.textContent = 'Complete My Order →'; }
    var errDiv=document.getElementById('checkoutError'); if(errDiv){errDiv.textContent='Request timed out. Please try again.';errDiv.style.display='block';}
  }, 15000);

  var variantId = parseInt(window.GIFTI_VARIANT_ID);

  if (!variantId || variantId === 0) {
    clearTimeout(safetyTimer);
    var errDiv=document.getElementById('checkoutError'); if(errDiv){errDiv.textContent='Product not found. Please contact hello@giftinsong.com';errDiv.style.display='block';}
    if (btn) { btn.disabled = false; btn.textContent = 'Complete My Order →'; }
    return;
  }

  var props = {
    'Song For':         DATA.recipient,
    'Occasion':         DATA.occasion,
    'Song Emotion':     DATA.emotion,
    'Music Style':      DATA.style,
    'Personal Story':   DATA.story,
    'Names to Include': DATA.names,
    'Special Details':  DATA.details,
    'Vocalist Voice':   DATA.voice,
    'Delivery Email':   DATA.email
  };

  // Try fetch first
  // Step 1: Clear cart so no old products accumulate
  fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
  .then(function() {
    // Step 2: Add the song product with all survey answers
    return fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1, properties: props })
    });
  })
  .then(function(r) {
    clearTimeout(safetyTimer);
    if (!r.ok) {
      return r.text().then(function(t) {
        try { var d = JSON.parse(t); throw new Error(d.description || d.message || r.status); }
        catch(e) { throw new Error('Cart error ' + r.status + ': ' + t.substring(0, 100)); }
      });
    }
    // Step 3: Go straight to checkout
    window.location.href = '/checkout?checkout[email]=' + encodeURIComponent(DATA.email || '');
  })
  .catch(function(err) {
    clearTimeout(safetyTimer);
    console.error('Fetch failed, trying form submit:', err);
    // Fallback: use the hidden form
    var form = document.getElementById('giftiCartForm');
    if (form) {
      // Remove old property inputs
      var old = form.querySelectorAll('input[name^="properties"]');
      old.forEach(function(el) { el.remove(); });
      // Add survey answers as form inputs
      Object.keys(props).forEach(function(k) {
        if (!props[k]) return;
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + k + ']';
        inp.value = props[k];
        form.appendChild(inp);
      });
      form.submit();
    } else {
      if (btn) { btn.disabled = false; btn.textContent = 'Complete My Order →'; }
      var errDiv=document.getElementById('checkoutError'); if(errDiv){errDiv.textContent='Error: '+(err.message||'Unknown')+'  Please try again or contact hello@giftinsong.com';errDiv.style.display='block';}
    }
  });
};

/* ── KEYBOARD: Enter advances ───────────────────────────── */
document.addEventListener('keydown', function(e){
  if(e.key !== 'Enter') return;
  var active = document.getElementById('step-' + currentStep);
  if(!active) return;
  /* Only advance if focus is NOT on a textarea */
  if(document.activeElement && document.activeElement.tagName === 'TEXTAREA') return;
  var nb = active.querySelector('.survey-next-btn');
  if(nb && !nb.disabled) nb.click();
});

/* ── INIT: start on step 1 ──────────────────────────────── */
updateProgress(1);

})();
